import { connect } from 'react-redux';
import { IState } from '../../../store';

import { IOtherCommercialCardProps, IOtherCommercialCardStoreProps, OtherCommercialCard } from './otherCommercialCard';

export function mapStateToProps(state: IState): IOtherCommercialCardStoreProps {
  const {
    experiments,
    isStalkerBannerShown,
    isBrandingAvailable,
    offerData: { offer, user, isHiddenByUser },
    hideOffer: { isTopPopupOpened, status, errorMessage },
    showAnalyticsButton,
  } = state;

  const isAnalyticsButtonShown = showAnalyticsButton && offer.cianId % 3 === 0;

  return {
    experiments,
    offer,
    isUserAuthenticated: user && user.isAuthenticated,
    isStalkerBannerShown,
    isBrandingAvailable,
    hideOfferStatus: status,
    hideOfferErrorMessage: errorMessage,
    isTopPopupOpened,
    isHiddenByUser,
    isAnalyticsButtonShown,
  };
}

export const OtherCommercialCardContainer = connect<IOtherCommercialCardStoreProps, {}, IOtherCommercialCardProps>(
  mapStateToProps,
)(OtherCommercialCard);
